import { render, staticRenderFns } from "./archivio.html?vue&type=template&id=07207174&scoped=true&"
import script from "./Archivio.vue?vue&type=script&lang=js&"
export * from "./Archivio.vue?vue&type=script&lang=js&"
import style0 from "./Archivio.vue?vue&type=style&index=0&id=07207174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07207174",
  null
  
)

export default component.exports